import { render, staticRenderFns } from "./InvoiceSidebarAddNewCustomer.vue?vue&type=template&id=c473656e&"
import script from "./InvoiceSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./InvoiceSidebarAddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSidebarAddNewCustomer.vue?vue&type=style&index=0&id=c473656e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports